###
# core JavaScript module for feldenkrais
#
# Sebastian Vogel - sebastian at svogel dot net
###

###jslint         browser : true, continue : true,
 devel  : true, indent  : 2,    maxerr   : 50,
 newcap : true, nomen   : true, plusplus : true,
 regexp : true, sloppy  : true, vars     : false,
 white  : true, plusplus: true, unparam  : true, todo: true
###

###global jQuery ###

fkm = (($) ->
  'use strict'

  # region ---------- BEGIN MODULE SCOPE VARIABLES --------------

  cM =
    ajaxURLs : [
      'aktuelles'
      'der-raum'
      'ueber-uns'
      'impressum'
      'newsletter'
      'feldenkrais-gruppenarbeit'
      'somatic-experiencing'
      'somatische-meditation'
      'feldenkrais-running'
      'feldenkrais-einzelarbeit'
      'ifs'
      'narm'
      'aktuelles'
    ]
    resizeInterval: 50
    overlayFadeTime: 500

    baseURL             : undefined
    rootPath            : undefined
    contentPath         : undefined


  sM =
    winHeight: undefined
    winWidth: undefined
    resizeToId: undefined

    currentPage     : undefined
    currentSubPage  : undefined
    currentStateURL : undefined


  jM = {}
  setjqMap = undefined
  initModule = undefined

  # endregion ------- END MODULE SCOPE VARIABLES ---------------

  # region ---------- BEGIN UTILITY METHODS ------------------
  # example : getTrimmedString

  getTarget = (pathname) ->
    return pathname.replace /\//g, ''

  # Will remove all falsy values: undefined, null, 0, false, NaN and "" (empty string)
  cleanArray = (actual) ->
    newArray = new Array
    i = 0
    while i < actual.length
      if actual[i]
        newArray.push actual[i]
      i++
    newArray

  getPathnameParts = (path_name) ->
    cleanArray path_name.split '/'


  setBaseURL = ->
    domain = location.protocol + '//' + location.hostname + ( if location.port then ':' + location.port else '' )
    cM.rootPath = '/'
    cM.baseURL = domain + cM.rootPath
    cM.contentPath = cM.rootPath + 'pages/'


  getURLContentPart = ->
    pathname = getPathnameParts(document.location.pathname)
    if pathname.length
      jM.body.removeClass 'home'
      jM.overlayContent.html ''
      if pathname[0] == 'index.php' || pathname[0] == 'index.html'
        window.location.href = '/'
        false
#      else

    if pathname.length == 1
      loadOverlay(pathname[0])


  getScrollTop = ->
    return Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop)


  # endregion ------- END UTILITY METHODS -------------------

  # region ---------- BEGIN DOM METHODS --------------------

  # Begin DOM method /setjqMap/

  setjqMap = ->
    jM = {
      window    : $ window
      title     : $ 'title'
      htmlbody  : $ 'html, body'
      body      : $ 'body'
      topimage  : $ '#topimage'
      header    : $ 'header'
      content   : $ '#content'
      navtoggle   : $ '#nav_toggle'
      menu     : $ '#main_menu'
      scroll_link : $ '.scroll-link'

      overlay           : $ '#overlay'
      overlayContent    : $ '#overlay_content'
      content_link      : $ 'a[href^="/"]'
      fkm_mail          : $ '.fkm-mail'
    }
    return

  # End DOM method /setjqMap/

  # endregion ------- END DOM METHODS ---------------------

  loadOverlay = (target) ->
    state_url = cM.rootPath + target + '/'
    if $.inArray(target, cM.ajaxURLs) < 0 then target = '404'
    url = '/pages/'+target+'.php'
    jM.title.text 'Feldenkrais Mitte - ' + target

    $.ajax(
      url : url
      type  : 'GET'
      dataType  : 'html'
      error : ( jqXHR, textStatus, error ) ->
        console.warn 'loadContent error : ', jqXHR, textStatus, error

      success : (resp, textStatus) ->

        jM.overlayContent.html(resp).append(
          $('<p/>')
          .addClass('p-teaser-link')
          .append(
            $('<a/>')
            .addClass('arrow-left')
            .attr('href', '#')
            .on('click', (e) ->
              e.preventDefault()
              closeOverlay()
              false
            )
          )
        )

        jM.body.addClass 'overlay'
        jM.overlayContent.find('.fkm-mail').each ->
          encodeEmails(this)
        jM.overlayContent.find('a[href^="/"]').not('.no-ajax').on('click', onClickPageLink)
        jM.overlay.fadeIn cM.overlayFadeTime
        jM.overlay.scrollTop 0

        history.pushState(jM.overlayContent[0].outerHTML, '', state_url)

        sM.currentStateURL = state_url

    )


  closeOverlay = (isPopStateEvent) ->
#    history.back()
    jM.overlay.fadeOut cM.overlayFadeTime, ->
      jM.overlayContent.html ''
      jM.body.removeClass 'overlay'
      jM.title.text 'Feldenkrais Mitte'
#      if !isPopStateEvent
      history.pushState('', '', '/')
      sM.currentStateURL = '/'




  encodeEmails = (elem) ->
    $this = $(elem)
    target = $this.data('name') || 'info'
    link_classes = $this.data 'link_classes'
    link = target + '@feldenkrais-mitte.de'
    link_text = link.replace('-', '&#8209;')
    text = $this.text() || link_text
    subject = $this.data 'subject'
    if subject
      link += '?subject='+subject

    $mailto_link = $('<a/>').attr(href: 'mailto:' + link).html(text)
    if link_classes then $mailto_link.addClass link_classes
    $this.html $mailto_link



  # region ---------- BEGIN EVENT HANDLERS -------------------
  # example: onClickButton = ...

  onClickPageLink = (e) ->
    e.preventDefault()
    $this = $(this)
    target = getTarget($this.attr('href'))
    if jM.menu.hasClass 'open'
      jM.navtoggle.trigger 'click'


    if jM.body.hasClass 'overlay'
      closeOverlay()
      setTimeout ->
        loadOverlay(target)
      , cM.overlayFadeTime + 100
    else
      loadOverlay(target)

    false

  onPopState = (event) ->
    pathname = getTarget(document.location.pathname)
    if !pathname || pathname == '/'
      closeOverlay()
#      jM.title.text 'Feldenkrais Mitte'
#      jM.body.addClass 'home'
    else
      jM.title.text 'Feldenkrais Mitte - ' + pathname
      jM.body.removeClass 'home'
      loadOverlay(pathname)

#    if sM.isMobile then scrollBodyToTop()

    sM.currentStateURL = pathname
    sM.currentPage = pathname
    state = JSON.stringify(event.state)


  # endregion ------- END EVENT HANDLERS --------------------

  # region ---------- BEGIN PUBLIC METHODS -------------------
  # Begin public method /initModule/
  # Purpose    : Initializes module
  # Arguments  :
  #  * $container the jquery element used by this feature
  # Returns    : true
  # Throws     : none
  #


  initModule = ->

    setjqMap()

    setBaseURL()

    $('.teaser-section').masonry
      columnWidth: '.grid-sizer',
      itemSelector: '.teaser',
      gutter: '.gutter-sizer',
#      horizontalOrder: true,
      fitWidth: true
#      true

    jM.window.on 'scroll', (e) ->
      if getScrollTop() >= sM.winHeight
        jM.header.addClass 'fixed'
      else
        jM.header.removeClass 'fixed'
      true


    jM.scroll_link.on 'click', (e) ->
      e.preventDefault()
      offset = 0
      target = @hash
      if $(this).data('offset') != undefined
        offset = $(this).data('offset')
      jM.htmlbody.stop().animate { 'scrollTop': $(target).offset().top - offset }, 500, 'swing', ->
      # window.location.hash = target;
        return
      false

    window.onpopstate = onPopState

    getURLContentPart true


    jM.content_link.on 'click', onClickPageLink

    $(document).on 'click', (e) ->
      if jM.body.hasClass 'overlay'
        $target = $(e.target)
        if !$target.closest('#overlay_content').length
          closeOverlay()

    jM.navtoggle.on 'click', ->
      jM.menu.toggleClass('open').slideToggle()


    jM.fkm_mail.each ->
      encodeEmails(this)

    true


  # End public method /initModule/
  # return public methods
  {
    initModule
  }

# endregion ------- END PUBLIC METHODS ---------------------

)(jQuery)

jQuery ->
  fkm.initModule()
  return